import { BigNumber } from '@ethersproject/bignumber'
import { Interface } from '@ethersproject/abi'
import {
  ChainId,
  STAKING_ABI,
  INTEGRAL_TOKEN,
  SIX_MONTHS_STAKING_ADDRESS,
  THREE_YEARS_STAKING_ADDRESS,
  DEPRECATED_SIX_MONTHS_STAKING_ADDRESS,
  DEPRECATED_THREE_YEARS_STAKING_ADDRESS,
} from '../../../constants'
import { Currency, CurrencyValue, formatCurrency } from '../../../model'

export const MONTHS_PER_YEAR = 12
export const OPTION1_PERCENTAGE_REWARD = 45
export const OPTION2_PERCENTAGE_REWARD = 10
export const OPTION1_DURATION_IN_MONTHS = 36
export const OPTION2_DURATION_IN_MONTHS = 6
export const AVG_MINING_TIME = 13 * 1000

export type Account = string | null
export const coder = new Interface(STAKING_ABI)

export enum StakingOption {
  THREE_YEARS,
  SIX_MONTHS,

  // Deprecated
  DEPRECATED_THREE_YEARS,
  DEPRECATED_SIX_MONTHS,
}

export function getStakingParams(stakingOption: StakingOption) {
  switch (stakingOption) {
    case StakingOption.THREE_YEARS:
      return {
        duration: `${OPTION1_DURATION_IN_MONTHS / MONTHS_PER_YEAR} Years`,
        apr: `${OPTION1_PERCENTAGE_REWARD}%`,
      }
    case StakingOption.SIX_MONTHS:
      return {
        duration: `${OPTION2_DURATION_IN_MONTHS} Months`,
        apr: `${OPTION2_PERCENTAGE_REWARD}%`,
      }

    // Deprecated
    case StakingOption.DEPRECATED_THREE_YEARS:
      return {
        duration: `${OPTION1_DURATION_IN_MONTHS / MONTHS_PER_YEAR} Years (Depr)`,
        apr: `${OPTION1_PERCENTAGE_REWARD}%`,
      }
    case StakingOption.DEPRECATED_SIX_MONTHS:
      return {
        duration: `${OPTION2_DURATION_IN_MONTHS} Months (Depr)`,
        apr: `${OPTION2_PERCENTAGE_REWARD}%`,
      }
  }
}

export function getStakingAddress(stakingOption: StakingOption, chainId: ChainId) {
  switch (stakingOption) {
    case StakingOption.THREE_YEARS:
      return THREE_YEARS_STAKING_ADDRESS[chainId]
    case StakingOption.SIX_MONTHS:
      return SIX_MONTHS_STAKING_ADDRESS[chainId]

    // Deprecated
    case StakingOption.DEPRECATED_THREE_YEARS:
      return DEPRECATED_THREE_YEARS_STAKING_ADDRESS[chainId]
    case StakingOption.DEPRECATED_SIX_MONTHS:
      return DEPRECATED_SIX_MONTHS_STAKING_ADDRESS[chainId]
  }
}

export function getStakingRewards(stakingOption: StakingOption, currency: Currency, value: string) {
  const currencyValue = CurrencyValue.fromString(currency, value)
  switch (stakingOption) {
    case StakingOption.THREE_YEARS:
      return calculateStakeRewards(currencyValue, OPTION1_PERCENTAGE_REWARD, OPTION1_DURATION_IN_MONTHS)
    case StakingOption.SIX_MONTHS:
      return calculateStakeRewards(currencyValue, OPTION2_PERCENTAGE_REWARD, OPTION2_DURATION_IN_MONTHS)

    // Deprecated
    case StakingOption.DEPRECATED_THREE_YEARS:
      return calculateStakeRewards(currencyValue, OPTION1_PERCENTAGE_REWARD, OPTION1_DURATION_IN_MONTHS)
    case StakingOption.DEPRECATED_SIX_MONTHS:
      return calculateStakeRewards(currencyValue, OPTION2_PERCENTAGE_REWARD, OPTION2_DURATION_IN_MONTHS)
  }
}

function calculateStakeRewards(currencyValue: CurrencyValue, percentage: number, periodInMonths: number) {
  return formatCurrency(
    currencyValue.currency.decimals,
    currencyValue.value.mul(percentage).mul(periodInMonths).div(MONTHS_PER_YEAR).div(100)
  )
}

export function getCurrencyValue(chainId: ChainId, value: BigNumber) {
  return value && new CurrencyValue(INTEGRAL_TOKEN[chainId], value)
}

export function createCall(address: string, functionName: string, args: any[]) {
  return {
    address,
    data: coder.encodeFunctionData(functionName, args),
  }
}

export function decodeResult(functionName: string, result: string) {
  return coder.decodeFunctionResult(functionName, result)[0]
}
